import { UiModal } from "@ui-monorepo/index";
import { WEB_ASSETS } from "@commons-monorepo/index";
import { allowSpecialCharacters } from "~/modules/catalogue/utils/format";
import { useShareStore } from "../../share-store.hook";
import styles from "./share-store-skin-1.module.css";
import { ShareStoreProps } from "../../share-store.types";
import { UiButton } from "~/components/ui-button";

export const ShareStoreSkin1 = ({ product }: ShareStoreProps) => {
  const {
    t,
    showModal,
    showProductModal,
    copySuccess,
    copyLink,
    sharedUrl,
    closeModal,
    handleSocialButton
  } = useShareStore();

  return (
    <UiModal
      title=''
      className='share-modal'
      show={showModal}
      onClose={closeModal}
      showHeader={false}
      content={{
        styles: {
          borderRadius: "1rem",
          height: "auto",
          width: `735px`
        }
      }}>

      <section className={styles.shareStoreStyled}>
        <header className={styles.shareStoreHeader}>
          <h3 className={styles.shareStoreTitle}>
            {t(!showProductModal ? "share.get_link" : "share.get_link_product")}
          </h3>
          <button className={styles.shareStoreClose} onClick={closeModal}>
            <span className='icon-close'></span>
          </button>
        </header>
        <div className={styles.shareStoreLink}>
          <input
            className={styles.sharedStoreUrl}
            type='text'
            readOnly
            defaultValue={sharedUrl()} />

          <UiButton
            hasPersonalization
            isFilled
            className={styles.sharedStoreCopy}
            onClick={copyLink}>

            <span className='icon-picture-in-picture'></span>
            {t("share.copy")}
          </UiButton>
        </div>
        <div className={styles.shareStoreSocials}>
          <a
            className={styles.socialShare}
            href={`https://wa.me/?text=${encodeURIComponent(
              t(
                !showProductModal ?
                "share.whatsapp_message" :
                "share.whatsapp_product_message",
                {
                  link: sharedUrl(),
                  interpolation: { escapeValue: false },
                  ...(showProductModal ?
                  { name: allowSpecialCharacters(product?.name || "") } :
                  {})
                }
              )
            )}`}
            target='_blank'
            rel='noreferrer'
            onClick={() => handleSocialButton("WA", showProductModal)}>

            <img
              src={`${WEB_ASSETS}/catalogue/logo_whatsapp.png`}
              alt='Whatsapp'
              className={styles.socialIcon} />

            <span className={styles.socialText}>{t("share.whatsapp")}</span>
          </a>
          <a
            className={styles.socialShare}
            href={`https://twitter.com/`}
            target='_blank'
            onClick={() => handleSocialButton("Twitter", showProductModal)}
            rel='noreferrer'>

            <img
              src={`${WEB_ASSETS}/catalogue/logo_twitter.png`}
              alt='Twitter'
              className={styles.socialIcon} />

            <span className={styles.socialText}>{t("share.twitter")}</span>
          </a>
          <a
            className={styles.socialShare}
            href={`https://www.facebook.com/`}
            target='_blank'
            onClick={() => handleSocialButton("FB", showProductModal)}
            rel='noreferrer'>

            <img
              src={`${WEB_ASSETS}/catalogue/logo_facebook.png`}
              alt='Facebook'
              className={styles.socialIcon} />

            <span className={styles.socialText}>{t("share.facebook")}</span>
          </a>
          <a
            className={styles.socialShare}
            href={`mailto:?subject=${t("share.details.store.title")}`}
            target='_blank'
            onClick={() => handleSocialButton("Email", showProductModal)}
            rel='noreferrer'>

            <span className={`${styles.socialIcon} icon-email-fill`}></span>
            <span className={styles.socialText}>{t("share.email")}</span>
          </a>
        </div>
        {copySuccess &&
        <div className={styles.shareStoreCopySuccess}>
            <span className='icon-circle-check'></span>
            <p className='copied'>{copySuccess}</p>
          </div>}

      </section>
    </UiModal>);

};